<script setup lang="ts">
  import { Monitor } from 'lucide-vue-next';

  defineProps<{
    showElectronicBlock: boolean;
  }>();
</script>

<template>
  <section class="flex flex-col gap-4 px-8 py-6" data-testid="record-config-archiving-section">
    <span class="text-sm font-semibold text-gray-07">Arquivamento:</span>

    <p
      v-if="!showElectronicBlock"
      class="text-sm text-gray-05"
      data-testid="record-config-archiving-hint"
    >
      Escolha o Formato para configurar o arquivamento
    </p>

    <div v-else class="flex flex-col gap-3" data-testid="record-config-archiving-electronic">
      <span class="flex items-center gap-2 text-sm font-semibold text-gray-07">
        <Monitor class="size-4 text-[var(--theme-secondary-ink)]" aria-hidden="true" />
        Sistema Eletrônico
      </span>
      <slot name="electronic">
        <p class="text-sm text-gray-05">Modelo e rotas de arquivamento eletrônico</p>
      </slot>
    </div>
  </section>
</template>
